import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import {
    AgentFilter,
    BusinessServiceFilter,
    StatusFilter,
    TestTypeFilter,
    TimeRangeFilter,
    useAgent,
} from '../../filters';
import { AgentStatusPanel, AgentDetailPanel } from '../../panels';
import PageActionsWithNg1DrillDown from '../../page-framework/page-header/PageActionsWithNg1DrillDown';

export const pageId = 'agent-detail';

export default function AgentDetailPage() {
    const agent = useAgent();
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={agent?.name}
                titleActions={
                    agent &&
                    !agent.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link to={`/admin/nPoints/${agent?.uuid}`} title={i18n._(t`Edit nPoint configuration`)}>
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
                actions={<PageActionsWithNg1DrillDown pageTitle={agent?.name} />}
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <AgentFilter required />
                    <BusinessServiceFilter />
                    <StatusFilter />
                    <TestTypeFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <AgentStatusPanel />
                <AgentDetailPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
